import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EbwModalService } from 'src/app/library/ebw-modals-angular/ebw-modal.service';
import {  AnalysisInterface } from 'src/app/modelli/inwit/analisi/analysis.interface';

import { GestioneUtentiService } from 'src/app/servizi/utenti/gestione-utenti.service';
import { ConfigService } from "src/app/servizi/config/config.service";


@Component({
  selector: 'app-analysis-property-modal',
  templateUrl: './analysis-property-modal.component.html',
  styleUrls: ['./analysis-property-modal.component.scss']
})
export class AnalysisPropertyModalComponent implements OnInit {
  public data;
  public groups;
  public users;
  
  apriDettaglioAnalisi:boolean = false;


 

  /** Riferimento alla modale aperta */
  modalRef: NgbModalRef = null;
  usernames: any;

  constructor(
    private modalService: NgbModal,
    private ebwModalService: EbwModalService,
    public modal: NgbActiveModal,
    private gestioneUtentiService: GestioneUtentiService,
    private configService: ConfigService
  ) { }

  ngOnInit(): void {
  
    let utente_loggato = this.gestioneUtentiService.userData.username;
    let gruppi_loggato = this.gestioneUtentiService.userData.groups;

    // console.log("PASSO QUI", utente_loggato, "user creatore ", this.data.users.user, this.data);
    if(!!this.data.rel_analysis_group){
      this.data.rel_analysis_group = 
        this.data.rel_analysis_group.map((_) => (
          { 
            group: !!_.group?.name ? _.group?.name : '', 
            user: ((!!_.user?.name ? _.user?.name : '') + ' ' + (!!_.user?.surname ? _.user?.surname : '')).trim()
          }
        ));

        this.groups = this.data.rel_analysis_group.map((_)=> _.group).filter(el => el).join(", ");
            
        let a = (this.data.rel_analysis_group.map((_)=> _.user)).filter(el => el)
        
        let b = a.reduce(function (accumulator, currentValue) {
          if (accumulator.indexOf(currentValue) === -1) {
            accumulator.push(currentValue);
          }
          return accumulator
        }, [])
    
        this.users = b.join(", ");
    }
    //restrictedAreaHelper: getAnalysis
    else {
      
      let tmpGroups = 
        this.data.groups.map((_) => (
          { 
            group: !!_.group?.name ? _.group?.name : '',      
          }
        ));

      let tmpUsers = 
        this.data.users.map((_) => (
          {         
            user: ((!!_.user?.name ? _.user?.name : '') + ' ' + (!!_.user?.surname ? _.user?.surname : '')).trim()
          }
        ));
        let tmpUsername = 
        this.data.users.map((_) => (
          { 
            user: !!_.user?.username ? _.user?.username : '',      
          }
        ));
     
      this.groups = tmpGroups.map((_)=> _.group).filter(el => el).join(", ");
      this.users = tmpUsers.map((_)=> _.user).filter(el => el).join(", ");
      this.usernames = tmpUsername.map((_)=> _.user).filter(el => el).join(", ");
      
    }
    // Il bottone che apre il dettaglio nel right sidebar deve essere visibile solo se l'utente ha
    // creato l'analisi oppure coincide almeno uno dei gruppi
    if ((gruppi_loggato.some(item =>this.groups.includes(item.name))) || (this.usernames == utente_loggato))
      {
        //console.log("mostro il bottone");
        this.apriDettaglioAnalisi = true;
      } 
      else
      {
        //console.log("I hides");
        this.apriDettaglioAnalisi = false;
      }
  }
}